import React, { useState, useEffect } from 'react';

import { connect } from "react-redux";
import * as msgs from "../../../constants/textConstants";
import * as types from "../../../constants/actionTypes";
import { withRouter } from "react-router-dom";
import { Navigation } from '../../ecosystem';
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import useInitialState from "./hooks/useInitialState";

const Nav = (props) => {
    const { siteMenuItems, onMenuChange, activeMenu, onLogoutClick, toggleMainMenu, clearSearch } = props;
    const [initialState, setInitialState] = useState(useInitialState(siteMenuItems, props));
    const [activeAccordion, setActiveAccordion] = useState(-1);
    const [activeAccordionMenu, setActiveAccordionMenu] = useState(-1);
    const [activeSubMenu, setActiveSubMenu] = useState(-1);
    const [navActiveMenu, setNavActiveMenu] = useState("");
    const [isMobile, setIsMobile] = useState(window && window.innerWidth > 768 ? false : true);

    useEffect(() => {
        setActiveAccordion(initialState.activeAccordion);
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            let windowWidth = window.innerWidth;

            // Check if mobile 
            if (windowWidth <= 768 && !isMobile) {
                setIsMobile(true);
            }
            else if (windowWidth > 768 && isMobile) {
                setIsMobile(false);
            }
        }
    }, [window.innerWidth]);

    useEffect(() => {
        const pathname = window.location.pathname;
        if (pathname === '/') {
            console.info(`Nav pathname '${pathname}'`);
            onMenuChange({ url: pathname });
            setActiveAccordion(-1);
        }
    }, [window.location.pathname]);

    return <>
        <Navigation
            className="menu-list-nav-container"
            menuItems={siteMenuItems}
            onNavHeadClick={(e, index, label) => {
                if (label && label.toLowerCase() === 'sign out') {
                    onLogoutClick();
                }
                const labelTxt = label ? label.replace(/\s+/g, '') : '';
                if (labelTxt) {
                    logUI(`MBHWeb.UI.Menu.${labelTxt}.Clicked`, new Date(), Tools.getURLPath());
                }
            }}
            onNavItemClick={(e, index, label) => {
                if (label && label.toLowerCase() === 'sign out') {
                    onLogoutClick();
                } else if (label && label.toLowerCase() === 'find care') {
                    clearSearch();
                }
                const labelTxt = label ? label.replace(/\s+/g, '') : '';
                if (labelTxt) {
                    logUI(`MBHWeb.UI.Menu.${labelTxt}.Clicked`, new Date(), Tools.getURLPath());
                }
            }}
            toggleMainMenu={() => { toggleMainMenu(); }}
        />
        {/*
            (siteMenuItems && siteMenuItems.length > 0) &&
                siteMenuItems.map(
                    (navHead, index, menuItems) => {
                        //console.info(`Menu navHead ${navHead.label} index '${index}' menuItems.length '${menuItems.length}' showDivider '${index < (menuItems.length - 1)}'`, navHead);
                        //const isMenuHeadActive = activeMenuHead && activeMenuHead.toLowerCase() === navHead.label.toLowerCase() ? true : false;
                        return navHead.show?(<nav key={`${navHead.label}${index}`}>
                            <Accordion
                                open={activeAccordion === index}
                                header={{
                                    "disabled": false,
                                    "disabledIndex": "",
                                    "icon": navHead.icon,
                                    "index": index,
                                    "isMobile": false,
                                    "label": navHead.label,
                                    "data": navHead
                                }}
                                index={index}
                                renderItem={navHead.navItems}
                                selectedMenuItem={activeMenu}
                                onItemClick={(e, i) => {
                                    setNavActiveMenu(i.url);
                                    onMenuChange(i);
                                    if (i.label === 'Sign Out') {
                                        onLogoutClick();
                                    }
                                }}
                                activeAccordion={activeAccordion}
                                onHeadClick={(accIdx, ensureOpen) => {//set the active accordion
                                    let activeId = accIdx===activeAccordion?-1:accIdx;
                                    if (menuItems[accIdx].label === 'Sign Out') {
                                        onLogoutClick();
                                    } else {
                                        setActiveAccordion(activeId);
                                        if (menuItems[accIdx] && menuItems[accIdx].url && menuItems[accIdx].url.trim().length!==0)
                                            onMenuChange({ url: menuItems[accIdx].url });
                                            //if(isMobile)
                                    }

                                }}
                                showDivider={(index < (menuItems.length - 1))}
                                initialState={initialState}
                            />

                            </nav>)
                        : <React.Fragment key={`${navHead.label}${index}`} ></React.Fragment>;
                    }
                )
            */}
    </>;
}
const mapDispatchToProps = (dispatch) => {
    return {
        onLogoutClick: () => dispatch({ type: types.LOGOUT, logoutMessage: msgs.UserInitiatedLogoutMessage }),
        clearSearch: () => {
            dispatch({ type: types.SEARCH_PROVIDER_CLEAR });
            dispatch({ type: types.SEARCH_LOCATION_CLEAR });
        }
    };
};
export default withRouter(connect(null, mapDispatchToProps)(Nav));

//export default connect(mapStateToProps, mapDispatchToProps)(ActiveUser);